import React from 'react';
import ReactDOM from 'react-dom/client';
import './fonts.css'; // Import Sarabun font family
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);